import React from "react";
import { ErrorMessage } from "formik";

export default ({ name }) => {
  return <ErrorMessage name={name}>{msg => <p style={{ fontSize: '12px', color: 'red', }}>{msg}</p>}</ErrorMessage>;
}
